// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { EndpointExpectedResponseVerbSchema } from '../inputTypeSchemas/EndpointExpectedResponseVerbSchema'

/////////////////////////////////////////
// ENDPOINT EXPECTED RESPONSE SCHEMA
/////////////////////////////////////////

export const EndpointExpectedResponseSchema = z.object({
  verb: EndpointExpectedResponseVerbSchema,
  responseCode: z.number().int(),
  indicator: z.string(),
  entity: z.string(),
  description: z.string(),
  isStateChanging: z.boolean(),
})

export type EndpointExpectedResponse = z.infer<typeof EndpointExpectedResponseSchema>

export default EndpointExpectedResponseSchema;
